import axios from "axios";

export const AXIOS = axios.create({
  baseURL: `${window.location.origin}/basissysteme.dokumente.rest-1.0/rest/baudarlehen/`,
  headers: {
    "Content-Type": "application/json"
  },
});
